const MAX_SUFFIX = 100;

/** Given existing names, return baseName with suffix if needed: "Foo" → "Foo (2)" → "Foo (3)" */
export function findUniqueName(
  baseName: string,
  existingNames: Set<string>,
  maxSuffix = MAX_SUFFIX
): string {
  if (!existingNames.has(baseName)) return baseName;
  for (let i = 2; i <= maxSuffix; i++) {
    const name = `${baseName} (${i})`;
    if (!existingNames.has(name)) return name;
  }
  return `${baseName} (${Date.now()})`;
}
